import { PolicyProductIdEnum, PurchasedProductInterface, RelationInterface } from 'outshared-lib';
import { coverageControlConfig } from '../config';
import { CoverageGroupTypeEnum } from '../enums';
import { CoverageControlCollectionInterface, CoverageControlConfigCollectionInterface } from '../interfaces';
import { CoverageGroupDefault } from './coverage-group-default.class';
import { CoverageGroupImplicit } from './coverage-group-implicit.class';
import { CoverageGroupRadio } from './coverage-group-radio.class';
import { CoverageGroupTable } from './coverage-group-table.class';
import { CoverageGroupToggle } from './coverage-group-toggle.class';
import { CoverageGroupAbstract } from './coverage-group.abstract';
import { CoverageGroupDynamic } from './coverage-group-dynamic.class';
import { CoverageGroupDisabled } from './coverage-group-disabled.class';
import { CoverageGroupCard } from './coverage-group-card.class';

/**
 * Creates an object which can be used by a coverage form control to display coverages.
 */
export class CoverageControl {
    // Base, extra or default container with coverage
    public collections: CoverageControlCollectionInterface[] = [];
    public productId: PolicyProductIdEnum;

    constructor(
        purchasedProduct: PurchasedProductInterface,
        relation: RelationInterface,
    ) {
        const collections = coverageControlConfig[purchasedProduct.productId];
        this.productId = purchasedProduct.productId;

        if (collections) {
            this.initialize(collections, purchasedProduct, relation);
        }
    }

    /**
     * Initialize configuration file and create groups and containers
     * @param containers coverage group containers from config
     */
    private initialize(
        collections: CoverageControlConfigCollectionInterface[],
        purchasedProduct: PurchasedProductInterface,
        relation: RelationInterface,
    ): void {
        this.collections = [];

        collections.forEach((collection): void => {
            if (!collection.groups) {
                return;
            }

            const _collection: CoverageControlCollectionInterface = {
                label: collection.label,
                groups: [],
            };

            collection.groups.forEach((group): void => {
                let _group: CoverageGroupAbstract;

                switch (group.type) {
                    case CoverageGroupTypeEnum.Implicit:
                        _group = new CoverageGroupImplicit(group, purchasedProduct);
                        break;
                    case CoverageGroupTypeEnum.Dynamic:
                        _group = new CoverageGroupDynamic(group, purchasedProduct);
                        break;
                    case CoverageGroupTypeEnum.Disabled:
                        _group = new CoverageGroupDisabled(group, purchasedProduct);
                        break;
                    case CoverageGroupTypeEnum.Radio:
                        _group = new CoverageGroupRadio(group, purchasedProduct);
                        break;
                    case CoverageGroupTypeEnum.Toggle:
                        _group = new CoverageGroupToggle(group, purchasedProduct);
                        break;
                    case CoverageGroupTypeEnum.Table:
                        _group = new CoverageGroupTable(group, purchasedProduct, relation);
                        break;
                    case CoverageGroupTypeEnum.Card:
                        _group = new CoverageGroupCard(group, purchasedProduct);
                        break;
                    default:
                        _group = new CoverageGroupDefault(group, purchasedProduct);
                        break;
                }

                _collection.groups.push(_group);
            });

            this.collections.push(_collection);
        });
    }
}
